<template>
  <vx-card>
    <div class="flex flex-nowrap">
      <div class="vx-col sm:w-1/2 lg:w-6/12">
        <vs-list>
          <draggable :list="AppActiveUser.cards.property_mappings.mappings.CONTACT.properties" group="people" class="cursor-move">
            <vs-list-item
              v-for="(listItem, index) in AppActiveUser.cards.property_mappings.mappings.CONTACT.properties"
              :key="index"
              :title="listItem.label"
              :subtitle="AppActiveUser.customer"
            >
              <vs-avatar slot="avatar" :src="AppActiveUser.wooImage" />
              <svg
                fill="#5b54c4"
                stroke="#5b54c4"
                stroke-width="20"
                height="42"
                viewBox="0 0 512 512"
                xmlns="http://www.w3.org/2000/svg"
                style="vertical-align: middle;float: right;"
              >
                <path
                  d="M506.134,241.843c-0.006-0.006-0.011-0.013-0.018-0.019l-104.504-104c-7.829-7.791-20.492-7.762-28.285,0.068
  c-7.792,7.829-7.762,20.492,0.067,28.284L443.558,236H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h423.557
  l-70.162,69.824c-7.829,7.792-7.859,20.455-0.067,28.284c7.793,7.831,20.457,7.858,28.285,0.068l104.504-104
  c0.006-0.006,0.011-0.013,0.018-0.019C513.968,262.339,513.943,249.635,506.134,241.843z"
                ></path>
              </svg>
            </vs-list-item>
          </draggable>
        </vs-list>
      </div>

      <div class="vx-col sm:w-1/2 lg:w-6/12 mb-base">
        <vs-list>
          <draggable :list="AppActiveUser.cards.property_mappings.mappings.CONTACT.properties" group="people" class="cursor-move">
            <vs-list-item
              v-for="(listItem, index) in AppActiveUser.cards.property_mappings.mappings.CONTACT.properties"
              :key="index"
              :title="listItem.label"
              :subtitle="AppActiveUser.contact"
            >
              <vs-avatar slot="avatar" :src="AppActiveUser.hubImage" />
            </vs-list-item>
          </draggable>
        </vs-list>
      </div>
    </div>
  </vx-card>
</template>

<script>
import draggable from "vuedraggable"
import { mapState } from 'vuex'

export default {
  components: {
    draggable
  },
  computed: {
    ...mapState(['AppActiveUser'])
  },
  methods: {
    resizeDivs: function() {
      var pHeight = 0;
      document
        .querySelectorAll(".vs-list--item")
        .forEach(function(element, idx, array) {
          var cHeight = element.getBoundingClientRect().height;
          if (cHeight > pHeight) {
            pHeight = cHeight;
          }
          if (idx === array.length - 1) {
            document.querySelectorAll(".vs-list--item").forEach(function(el) {
              el.style.minHeight = pHeight + "px";
            });
          }
        });
    }
  },
  mounted() {
    this.resizeDivs();
    // Register an event listener when the Vue component is ready
    window.addEventListener("resize", this.resizeDivs);
  },
  beforeDestroy() {
    // Unregister the event listener before destroying this Vue instance
    window.removeEventListener("resize", this.resizeDivs);
  }
};
</script>

<style lang="scss">
.vs-list--slot {
  margin-right: 0 !important;
}
</style>
